import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolLpAction } from '@cbridge-packages/symbol-lp';
import { MultiSelectSidebarAction } from '@cbridge-packages/multi-select-sidebar';

export const closeBulkEditSidebarOnDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolLpAction.bulkUpdate.done,
    SymbolLpAction.bulkRemove.done,
  ),
  mergeMap(() => [
    MultiSelectSidebarAction.closeBulkEditSidebar(),
    MultiSelectSidebarAction.clearSelection(),
  ]),
);
